import { render, staticRenderFns } from "./BlogSection.vue?vue&type=template&id=677c00eb&scoped=true&lang=pug&"
import script from "./BlogSection.vue?vue&type=script&lang=js&"
export * from "./BlogSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c00eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677c00eb')) {
      api.createRecord('677c00eb', component.options)
    } else {
      api.reload('677c00eb', component.options)
    }
    module.hot.accept("./BlogSection.vue?vue&type=template&id=677c00eb&scoped=true&lang=pug&", function () {
      api.rerender('677c00eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BlogSection.vue"
export default component.exports